package com.rosario.juridico.domain

data class PlazoRecord(
    val categoria: String,
    val descripcion: String,
    val valor: String,
    val tipoComputo: String,
    val articulo: String,
    val observaciones: String
)
